import { defineComponent as _defineComponent } from 'vue'
import { trackEvent } from '@@/bits/analytics'
import device from '@@/bits/device'
import { emojiUrl } from '@@/bits/emoji'
import { observeElementIntersection } from '@@/bits/intersection'
import { __ } from '@@/bits/intl'
import type {
  AiImageSearchResult,
  AudioSearchResult,
  ImageSearchResult,
  VideoSearchResult,
  WebSearchResult,
} from '@@/bits/web_search'
import { SearchFilters } from '@@/bits/web_search'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzIndeterminateSpinner from '@@/library/v4/components/OzIndeterminateSpinner.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import ContentPickerSearchResultsAv from '@@/vuecomponents/ContentPickerSearchResultsAv.vue'
import ContentPickerSearchResultsImage from '@@/vuecomponents/ContentPickerSearchResultsImage.vue'
import ContentPickerSearchResultsWeb from '@@/vuecomponents/content-picker-search-results-web.vue'
import WebBrowserAttribution from '@@/vuecomponents/web_browser_attribution.vue'
import { processedUrl } from '@padlet/vivaldi-client'
import { storeToRefs } from 'pinia'
import { nextTick, onUnmounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSearchResults',
  props: {
    isOnline: { type: Boolean },
    searchQuery: null,
    searchFilter: null,
    results: null,
    isSearchQueryInProgress: { type: Boolean },
    isSearchMoreQueryInProgress: { type: Boolean },
    isAiImageSearchMode: { type: Boolean },
    canSearchMore: { type: Boolean },
    hasError: { type: Boolean }
  },
  emits: ["select", "search-more", "clear-search-error"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'select', data: string): void
  (name: 'search-more'): void
  (name: 'clear-search-error'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOnline: boolean
  searchQuery: string
  searchFilter: SearchFilters | null
  results: (AudioSearchResult | WebSearchResult | VideoSearchResult | ImageSearchResult | AiImageSearchResult)[]
  isSearchQueryInProgress: boolean
  isSearchMoreQueryInProgress: boolean
  isAiImageSearchMode: boolean
  canSearchMore: boolean
  hasError: boolean
};





// From JoyPixels
const EMOJIS = {
  '1f626': {
    code: '1f626',
    category: 'people',
    shortname: ':frowning:',
    name: 'frowning face with open mouth',
    keywords: ['face', 'frown', 'mouth', 'open'],
    url: emojiUrl('png', '1f626'),
  },
  '1f633': {
    code: '1f633',
    category: 'people',
    shortname: ':flushed:',
    name: 'flushed face',
    keywords: ['dazed', 'face', 'flushed'],
    url: emojiUrl('png', '1f633'),
  },
  '1f634': {
    code: '1f634',
    category: 'people',
    shortname: ':sleeping:',
    name: 'sleeping face',
    keywords: ['face', 'sleep', 'zzz'],
    url: emojiUrl('png', '1f634'),
  },
}

const isMobile = device.mobile
const { isDarkMode } = storeToRefs(useDarkModeStore())

const resultBody = ref<HTMLDivElement | null>(null)

const hasNoResults = ref<boolean>(false)
const intersectionObserver = ref<IntersectionObserver | null>(null)

const processedIconUrl = (icon: object & { url: string }): string => {
  return processedUrl(icon.url, { width: 64, height: 64, preset: 'icon' })
}

const select = (data: string): void => {
  if (props.isAiImageSearchMode) {
    trackEvent('AI Image Search', 'Selected image from AI search')
  }
  emit('select', data)
}

watch(
  () => props.results,
  (): void => {
    nextTick(() => {
      // necessary to wait for the element to appear
      const searchMoreTrigger = document.querySelector('#search-more-trigger') as HTMLDivElement
      if (searchMoreTrigger) {
        intersectionObserver.value = observeElementIntersection(searchMoreTrigger, () => {
          emit('search-more')
        })
      }
    })
  },
)

watch([() => props.isSearchQueryInProgress, () => props.searchFilter], (): void => {
  let xResults = true
  if (props.searchQuery) {
    xResults = props.results && props.results.length > 0
  }
  hasNoResults.value = !xResults
})

watch(
  () => props.searchFilter,
  (): void => {
    if (!resultBody.value) return
    resultBody.value.scrollTop = 0
  },
)

watch(
  () => props.isOnline,
  (): void => {
    emit('clear-search-error')
  },
)

onUnmounted(() => {
  const searchMoreTrigger = document.querySelector('#search-more-trigger') as HTMLDivElement
  if (intersectionObserver.value !== null && searchMoreTrigger) {
    intersectionObserver.value.unobserve(searchMoreTrigger)
  }
})

return { __sfc: true,props, emit, EMOJIS, isMobile, isDarkMode, resultBody, hasNoResults, intersectionObserver, processedIconUrl, select, __, SearchFilters, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzIndeterminateSpinner, ContentPickerSearchResultsAv, ContentPickerSearchResultsImage, ContentPickerSearchResultsWeb, WebBrowserAttribution }
}

})